import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  PuntoDeFeSection,
  Products,
  ValueAdd,
  InvestmentSummary,
  AreYouReady,
} from './components';

const LandingMediaKitNexusCultural = ({ themeMode = 'light' }) => {
  return (
    <Box>
      <Container>
        <Hero themeMode={themeMode} />
      </Container>
      <Container>
        <PuntoDeFeSection />
      </Container>
      <Container>
        <Products />
      </Container>
      <Container>
        <ValueAdd />
      </Container>
      <Container>
        <InvestmentSummary />
      </Container>
      <Container>
        <AreYouReady />
      </Container>
    </Box>
  );
};

LandingMediaKitNexusCultural.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitNexusCultural;
